/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_Create_FailedInputs */

const cs_settings_users_create_failed = /** @type {(inputs: Settings_Users_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uživatele se nepodařilo vytvořit. Účet mohl zůstat neúplný — zkontrolujte seznam a zkuste to znovu.`)
};

const en_settings_users_create_failed = /** @type {(inputs: Settings_Users_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not create the user. An incomplete account may remain — check the list and retry.`)
};

/**
* | output |
* | --- |
* | "Could not create the user. An incomplete account may remain — check the list and retry." |
*
* @param {Settings_Users_Create_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_create_failed = /** @type {((inputs?: Settings_Users_Create_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_Create_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_create_failed(inputs)
	return cs_settings_users_create_failed(inputs)
});